import { useEffect, useState } from "react";
import { MinusIcon, PlusIcon } from "lucide-react";

export const ConsultationFilterMenu = ({
  selectedFilters,
  setSelectedFilters,
  refetch,
}: {
  selectedFilters: Record<string, string>;
  setSelectedFilters: (v: any) => void;
  refetch: (data: any) => void;
}) => {
  const [openKey, setOpenKey] = useState<string | null>(null);

  const toggle = (key: string) => {
    setOpenKey((prev) => (prev === key ? null : key));
  };

  const setFilter = (key: string, value: string) => {
    setSelectedFilters((prev: any) => ({
      ...prev,
      [key]: value, // overwrite previous selection
    }));
  };

  useEffect(() => {
    if (!selectedFilters || Object.keys(selectedFilters).length === 0) return;
    refetch(selectedFilters);
  }, [selectedFilters]);

  return (
    <div className="w-60 p-4 rounded-xl bg-[#F7E4D4] custom_shadow">
      <FilterItem
        label="Dates"
        keyName="date"
        selectedValue={selectedFilters.date}
        isOpen={openKey === "date"}
        onClick={() => toggle("date")}
        options={["Today", "Yesterday"]}
        onSelect={setFilter}
      />

      <FilterItem
        label="Status"
        keyName="status"
        selectedValue={selectedFilters.status}
        isOpen={openKey === "status"}
        onClick={() => toggle("status")}
        options={["PENDING", "COMPLETED", "CANCELLED", "APPROVED"]}
        onSelect={setFilter}
      />
    </div>
  );
};

const FilterItem = ({
  label,
  keyName,
  isOpen = false,
  onClick,
  options = [],
  selectedValue,
  onSelect,
}: {
  label: string;
  keyName: string;
  isOpen?: boolean;
  selectedValue?: string;
  onClick?: () => void;
  options?: string[];
  onSelect?: (key: string, value: string) => void;
}) => {
  const hasChildren = options.length > 0;

  return (
    <div className="mb-3">
      <div
        className="flex items-center justify-between border-b border-[#B4B4B466] pb-2 cursor-pointer"
        onClick={() => {
          if (!hasChildren) onSelect?.(keyName, label);
          else onClick?.();
        }}
      >
        <span className="font-medium">
          {label} {selectedValue ? `: ${selectedValue}` : ""}
        </span>

        {hasChildren &&
          (isOpen ? (
            <MinusIcon size={18} className="text-black" />
          ) : (
            <PlusIcon size={18} className="text-black" />
          ))}
      </div>

      {hasChildren && isOpen && (
        <div className="mt-2 pl-2 space-y-1">
          {options.map((opt) => (
            <div
              key={opt}
              className={`cursor-pointer hover:text-primary ${
                selectedValue === opt ? "font-semibold text-primary" : ""
              }`}
              onClick={(e) => {
                e.stopPropagation();
                onSelect?.(keyName, opt);
              }}
            >
              • {opt}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
